import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { designTokens, baseColors } from "theme";

export const styles = (theme: Theme) => {
	return {
		title: {
			display: "flex",
			alignItems: "center",
			gap: 8,
			fontSize: 18,
			fontWeight: 700,
			color: baseColors.darkCharcoal,
			paddingRight: 48,
		},
		titleIcon: {
			fontSize: 16,
			color: theme.palette.primary.main,
		},
		closeButton: {
			position: "absolute",
			top: 8,
			right: 8,
			color: designTokens.colors.iconNeutral,
		},
		content: {
			display: "flex",
			flexDirection: "column",
			gap: 16,
			padding: theme.spacing(3),
			[theme.breakpoints.up("sm")]: {
				width: 520,
			},
		},
		row: {
			display: "flex",
			alignItems: "flex-start",
			gap: 8,
		},
		// The lead reads on the right, the agent on the left — the same sides the conversation
		// used on the consumer site, so an agent recognizes who said what without a legend.
		rowLead: {
			flexDirection: "row-reverse",
		},
		avatar: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			width: 28,
			height: 28,
			borderRadius: "50%",
			flexShrink: 0,
		},
		avatarLead: {
			backgroundColor: designTokens.colors.divider,
			color: baseColors.darkCharcoal,
		},
		avatarAgent: {
			backgroundColor: designTokens.colors.tagInfoSurface,
			color: theme.palette.primary.main,
		},
		avatarIcon: {
			fontSize: 14,
		},
		column: {
			display: "flex",
			flexDirection: "column",
			gap: 4,
			minWidth: 0,
			maxWidth: "78%",
		},
		columnLead: {
			alignItems: "flex-end",
		},
		bubble: {
			borderRadius: 8,
			padding: "10px 12px",
			fontSize: 14,
			lineHeight: "22px",
			color: baseColors.darkCharcoal,
			// Content is plain text, so its own line breaks are all the structure it has.
			whiteSpace: "pre-wrap",
			overflowWrap: "break-word",
		},
		bubbleLead: {
			backgroundColor: designTokens.colors.tagInfoSurface,
		},
		bubbleAgent: {
			backgroundColor: designTokens.colors.grayLight,
			border: `1px solid ${designTokens.colors.divider}`,
		},
		time: {
			fontSize: 12,
			color: designTokens.colors.grayDark,
		},
		empty: {
			fontSize: 14,
			color: designTokens.colors.grayDark,
		},
		suggestion: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			flexWrap: "wrap",
			gap: theme.spacing(1.5),
			margin: theme.spacing(0, 3),
			padding: theme.spacing(1.5, 2),
			borderRadius: 8,
			backgroundColor: baseColors.orange25,
		},
		suggestionText: {
			display: "flex",
			alignItems: "center",
			gap: 8,
			fontSize: 14,
			color: baseColors.darkCharcoal,
		},
		suggestionHeading: {
			fontWeight: 700,
		},
		suggestionIcon: {
			fontSize: 16,
			color: designTokens.colors.brandOrange,
		},
		suggestionActions: {
			display: "flex",
			gap: theme.spacing(1),
		},
	} satisfies Record<string, CSSObject>;
};
